import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiGet } from "../../app/api";
import { ROUTES } from "../../app/routes";

// Async thunk to fetch dashboard graphs data
export const fetchDashboardGraphs = createAsyncThunk(
  "dashboard/fetchDashboardGraphs",
  async (_, { rejectWithValue }) => {
    try {
      const data = await apiGet(ROUTES.GET_DASHBOARD_DATA);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


const dashboardGraphsSlice = createSlice({
  name: "dashboardGraphs",
  initialState: {
    data: null as any,
    loading: false,
    error: null as string | null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDashboardGraphs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDashboardGraphs.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchDashboardGraphs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ? String(action.payload) : null;
      });
  },
});

export default dashboardGraphsSlice.reducer;
